/* eslint-disable */
import React from 'react';

export const Footer00DataSource = {
    wrapper: {className: 'home-page-wrapper footer0-wrapper'},
    OverPack: {className: 'home-page footer0', playScale: 0.05},
    copyright: {
        className: 'copyright',
        children: (
            <>
                <span>©南京雨后地软环境技术有限公司版权所有</span>
            </>
        ),
    },
};

/*export const NewsDetailDataSource = [
    {
        title: "公司顺利入库“科技型中小企业”", feTitle: "发布日期：2018-11-28 ",
        imgList: [],
        videoUrl:"",
        textList: [
            "近日，由江苏省科学技术厅发布的《江苏省科技厅关于2018年入库科技型中小企业的公告》中，我司名列其中， （入库登记编号 2018320106A0014402），并且顺利通过公示。",
        ],
    },
    {
        title: "“广西大气源清单模型建立及运行项目”顺利通过专家评审", feTitle: "发布日期：2018-12-18 ",
        imgList: [{title: "", url: "img/newsDetail2.jpg"}],
        videoUrl:"",
        textList: [
            "2018年12月14日，广西壮族自治区环境保护科学研究院组织召开了 “广西大气源清单模型建立及运行项目” 验收会。会议邀请国防科技大学、广西气象台等单位的行业专家组成专家组。会上，专家组听取了我公司的项目成果汇报， 审阅了技术报告等有关材料，认为项目完成了合同中的建设内容，达到各项指标要求，技术路线合理，方法先进，预报结果可靠。 专家组一致同意通过验收。",
            "该项目建成了广西空气质量多模式预报系统，部署了WRF、WRF-Chem、CAMx模式系统，并实现自动化运行。 能提供广西未来72小时逐小时的空气质量预报及未来4-7天的趋势预报，重点城市分辨率达到1km，可实现颗粒物和臭氧的区域解析、 分类源解析及情景模拟功能。",
        ],
    },
    {
        title: "“气溶胶激光雷达光学厚度同化对空气质量预报的应用研究 项目”顺利通过专家评审", feTitle: "发布日期：2018-12-28 ",
        imgList: [],
        videoUrl:"",
        textList: [
            "2018年12月26日，江苏省环境监测中心在南京组织召开“气溶胶激光雷达光学厚度同化对空气质量预报的应用研 究项目”验收会。该项目由我公司承接。会议邀请了南京信息工程大学、江苏省环境科学研究院、南京市环境监测中心、 常州市环境监测中心等单位的行业专家组成专家组，经过专家评审，一致同意通过验收。",
            "本项目采用三维变分方法对激光雷达AOD资料进行同化研究，构建了一套与江苏省空气质量预报系统相适应的 激光雷达AOD同化系统，解决了激光雷达AOD资料在空气质量预报模拟应用中的关键技术问题，提升了空气质量模拟预报准确性。",
        ],
    },
    {
        title: "公司入选“创业南京”英才计划", feTitle: "发布日期：2019-01-12 ",
        imgList: [],
        videoUrl:"",
        textList: [
            "根据《关于建设具有全球影响力创新名城的若干政策措施》（宁委发﹝2018〕1号）和南京市委、市政府关于 推进实施“创业南京”英才计划的若干文件精神，经在线申报、资格认定、技术评审、综合评审、审定公示等环节，我公司总经理任杰先生 入选南京市2018年度“高层次创业人才引进计划”、“创新型企业家培育计划”。",
            "高层次创业人才，主要指符合南京市新兴产业发展和产业转型升级方向，带团队、带技术、带项目在宁创办企业 的行业领军人才。要求引进对象具有硕士以上学位或副高以上职称，拥有独立自主知识产权或掌握核心技术，技术成果达到国际先进 或国内领先水平，具有良好产业化潜力和市场前景。",
            "创新型企业家，主要指既懂科技又懂市场，在相关领域开创技术新路径、商业新模式、产业新质态， 对南京市实施创新驱动发展和经济转型升级起到引领示范作用的企业家。",
            "南京计划从2016年起，用5年时间，重点引进扶持1000名高层次创业人才，重点培育200名创新型企业家， 培育对象创办企业中，新增挂牌上市30家，年销售收入超亿元30家，年纳税额超千万元 10家。对于入选高层次创业人才引进计划 及创新型企业家的，南京市财政将给与150万元的资金扶持，提供5年累计不超过3000万元贷款总额的贴息，提供人才公寓、 最高500平方米创业场所等一系列优惠政策。",
        ],
    },
    {
        title: "青青雨后，与我同行——雨后地软召开2019年新春年会", feTitle: "发布日期：2019-01-18 ",
        imgList: [
            {title: "", url: "img/newsDetail3.jpg"},
            {title: "", url: "img/newsDetail4.jpg"},
            {title: "", url: "img/newsDetail5.jpg"},
            {title: "", url: "img/newsDetail6.jpg"},
            {title: "", url: "img/newsDetail7.jpg"},
            {title: "", url: "img/newsDetail8.jpg"},
            {title: "", url: "img/newsDetail9.jpg"},
            {title: "", url: "img/newsDetail10.jpg"},
        ],
        videoUrl:"",
        textList: [
            "青青雨后，与我同行——雨后地软2019年新春年会于2019年1月18日在南京丁山宾馆隆重举行，全体员工欢聚一堂，共度联欢。",
            "总经理任杰先生做了工作报告，总结了公司2018年度取得的成绩，明确了公司2019年经营的总体规划。 任总指出，2018年公司先后在广西、云南、海南、新疆、江苏、甘肃、青海、河南等地拓展了项目，合同实现新突破，技术实现新跨越， 品牌得到大提升，团队实现高成长。2019年，公司会秉承“至诚至善，合作共赢”的价值观，进一步夯实技术实力，深耕市场， 以客户为中心，把承接的每个项目打造成精品，并让员工共享公司发展成果。",
            "会上，公司对2018年度的优秀员工、技术创新奖获得者进行了表彰和奖励。各部门员工也带来了形式多样、 让人目不暇接的表演：舞蹈、相声、琴艺、武术等节目，精彩纷呈；穿插着各式各样小游戏和抽奖环节，更是将年会的气氛推向高潮。",
        ],
    },
    {
        title: "公司通过高新技术企业认证", feTitle: "发布日期：2019-02-15",
        imgList: [{title: "", url: "img/newsDetail1.jpg"}],
        videoUrl:"",
        textList: [
            "2018年10月24日，国家科技部全国高新技术企业认定管理工作领导小组办公室，通过科技部火炬中心官网发布 ——江苏省2018年第一批拟认定高新技术企业名单的公示通知，我公司榜上有名。近日，公司顺利通过公示，被认定为国家高新技术企业。",
            "我公司此次顺利通过国家高新技术企业认定，标志着在专利技术、市场推广、企业内控、研发投入、 经营业绩等方面均达到一定水平高度，符合国家、省市有关部门硬性指标要求，代表我公司综合实力已再上新台阶。 公司将以此为契机，进一步加强技术创新能力及科技成果转化能力，不断创新发展大气、环保及生态领域的预测、 模拟与决策服务技术，引领科技进步，以可持续发展理念实现客户目标！",
        ],
    },
    {
        title: "西宁电视台报道本市大气环境网格化监管系统”", feTitle: "发布日期：2019-04-01 ",
        imgList: [],
        textList: [
            "西宁电视台新闻综合频道对“西宁市大气环境网格化监管系统”做了深入报道。 该系统由我公司承建，依托于高性能并行计算平台支撑，融合了大气环境分析预报机理和大气环境网格化监管机制， 利用科学先进的数值模式技术、同化技术、数据分析技术、GIS技术及计算机相关技术等手段， 实现大气污染预报预警与防控决策的网格化、精细化和智能化应用。系统应用后，将有力提升西宁市大气环境防控与综合治理能力， 为改善环境空气质量发挥科技先锋和专家智囊作用。",
        ],
        videoUrl: "img/video1.mp4",
    },
];*/
